module.exports = __webpack_public_path__ + "img/search-normal.ed9e2fc7.svg";